import { Typography } from '@mui/material';
import * as React from 'react';

export const ClustersPage: React.FunctionComponent = () => {
    return <Typography>Clusters page: Work in progress</Typography>;
};
